class SearchForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()
    this.listeners.add(this, 'submit', this.handleFormSubmit)
  }

  handleFormSubmit (e) {
    e.preventDefault()

    const searchTerm = this.getSearchTerm()

    if (this.isSearchRedirectsEmpty() || !searchTerm) {
      this.submit()
      return
    }

    const redirectUrl = this.findRedirectUrl(searchTerm)

    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      this.submit()
    }
  }

  /**
   * Retrieves the search term from the input field
   * @returns {string|null}
   */
  getSearchTerm () {
    return this.input?.value?.toLowerCase().trim() || null
  }

  /**
   * Checks if search redirects are available
   * @returns {boolean}
   */
  isSearchRedirectsEmpty () {
    return (
      !window.BAO.searchRedirects || window.BAO.searchRedirects.length === 0
    )
  }

  /**
   * Finds the redirect URL for a given search term
   * @param {string} searchTerm
   * @returns {string|null}
   */
  findRedirectUrl (searchTerm) {
    const redirectObject = window.BAO.searchRedirects.find(
      (object) => object.searchTerm === searchTerm,
    )
    return redirectObject ? redirectObject.redirectUrl : null
  }

  /**
   * @returns {HTMLElement|null}
   */
  get input () {
    return this.querySelector('input[type="search"]')
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm, { extends: 'form' })
}
